module.exports = __webpack_public_path__ + "img/watch_featuress.b337bdd7.png";